import { Actions, createEffect, ofType } from '@ngrx/effects';
import { WidgetService } from '../../shared/services/widget.service';
import { Store } from '@ngrx/store';
import { WidgetState } from './widget_state';
import { LogService } from '../../../shared/services/log.service';
import { Injectable } from '@angular/core';
import { ToastService } from '../../../shared/services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import { REDCRSS_EVENTS } from '../../../shared/services/constants/redcross_evemts';
import { ShopifyService } from '../../shared/services/shopify.service';
import { catchError, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import { widgetSaveSettings, widgetSkip, widgetUpdate } from './widget_actions';
import { AnalyticsTrackingProvider } from '@yotpo-ui/core';

@Injectable()
export class WidgetEffects {

  saveData = createEffect(() => this.action$.pipe(
    ofType(widgetSaveSettings),
    withLatestFrom(this.store$),
    mergeMap(([_, state]) => {
      let widgetState = state['app']['install']['widget'];
      this.redCrossService.track('Feature Update', {
        feature: 'Reviews Widget',
        updatedWidgetFont: widgetState.font,
        updatedPrimaryColor: widgetState.primaryColor,
        updatedStarsColor: widgetState.starRatingColor
      });

      this.trackCompleted(widgetState, 'next');

      return this.widgetService.saveWidgetData(widgetState).pipe(
        catchError(error => {
          let errMsg = this.translate.instant('WIDGET.SAVE_FAILED');
          this.toastrService.error('install', 'WidgetEffects', errMsg, error);
          return of(widgetUpdate({payload: { doneInstallation: false }}));
        }),
        map(() => {
          this.logger.log('widget data saved');
          return widgetUpdate({payload: { doneInstallation: false }});
        }));
    })));

  skipWidget = createEffect(() => this.action$.pipe(
    ofType(widgetSkip),
    withLatestFrom(this.store$),
    map(([_, state]) => {
      let widgetState = state['app']['install']['widget'];

      this.trackCompleted(widgetState, 'skip');
    })),
    {
      dispatch: false
    });

  trackCompleted(widgetState: WidgetState, ctaText: string) {
    this.shopifyService.isShopify2().subscribe(data => {
      this.redCrossService.track(REDCRSS_EVENTS.ONBOARDING, {
        category: 'Reviews',
        phaseName: 'Onboarding Step 2',
        phase: 2,
        status: 'completed',
        isAutoPublishEnabled: widgetState.autoPublish,
        isWidgetFontUpdated: widgetState.fontChanged,
        isPrimaryColorUpdated: widgetState.primaryColorChanged,
        isStarsColorUpdated: widgetState.starRatingColorChanged,
        ctaText: ctaText,
        os20: data.response
      });
    });
  }

  constructor(private action$: Actions,
              private widgetService: WidgetService,
              private store$: Store,
              private logger: LogService,
              private redCrossService: AnalyticsTrackingProvider,
              private toastrService: ToastService,
              private translate: TranslateService,
              private shopifyService: ShopifyService) {
  }
}
